module.exports = __webpack_public_path__ + "img/tjx_d_7.05ab3301.png";